export enum LicenseType {
  None,
  BrazilGLA
}
